import React from "react";
import { Translate } from "react-redux-i18n";
import { connect } from "react-redux";
import { Button, Icon } from "@blueprintjs/core";
import FormatedPrice from "../../components/FormatedPrice";
import StickyBox from "react-sticky-box";
import { fetchCircle } from "../../store/circles/operations";
import Breadcrumb from "../../components/Breadcrumb";
import { navigate } from "../../store/navigation/operations";
import UserDecorator from "../../containers/UserDecorator";
import LoadingIndicator from "../../components/LoadingIndicator";
import CircleCreator from "../../components/CircleCreator";

import CustomIcon from "../../components/CustomIcon";
import JoinRequestDecorator from "../../containers/JoinRequestDecorator";
import { getCircleWithId, isFetchingCircle, isWhiteMondayCircle } from "../../store/circles/selectors";
import CircleImage from "../../components/Image/CircleImage";
import { CircleHelmet } from "../../components/helmets";
import CircleStatus from "../../components/CircleStatus";

class CirclePresentation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };
  }

  componentDidMount() {
    this.props.fetchCircle(this.props.circleId);
  }

  render() {
    //TODO: add icons
    const breadcrumbItems = this.props.circle
      ? [
          {
            onClick: () => {
              this.props.navigate("/");
            },
            icon: "document",
            text: <Translate value="menu.home" />,
          },
          { icon: "document", text: this.props.circle.products[0].name },
        ]
      : [];

    if (this.props.circleCollection && this.props.circle) {
      let breadcrumb_item = {
        onClick: () => {
          this.props.navigate(`/collection/${this.props.circleCollection}`);
        },
        icon: "document",
        text: this.props.circleCollection,
      };
      breadcrumbItems.splice(1, 0, breadcrumb_item);
    }
    return (
      <>
        <Breadcrumb breadcrumbItems={breadcrumbItems} />
        <section>
          <div className="main-container">
            <div className="content-wrapper">
              {this.props.loadingCircle && <LoadingIndicator />}
              {!this.props.loadingCircle && this.props.circle && (
                <>
                  <CircleHelmet circle={this.props.circle} />
                  <div className="product-details">
                    <div className="product-image">
                      <CircleImage
                        src={this.props.circle.products[0].image_url}
                        size="medium"
                        alt={this.props.circle.products[0].name}
                      />
                    </div>
                    <div className="product-details-wrapper">
                      <div className="product-meta">
                        <div
                          className={`product-description default-circle ${
                            this.state.expanded ? "expanded" : "collapsed"
                          }`}>
                          <div className="old-price">
                            <FormatedPrice
                              value={this.props.circle.products[0].price}
                              currency_type={this.props.circle.products[0].currency}
                            />
                          </div>
                          <h1 className="bp3-heading">{this.props.circle.products[0].name}</h1>
                          {this.props.circle.products[0].url && (
                            <a href={this.props.circle.products[0].url} target="_blank" rel="noopener noreferrer" className="product-url">
                              <Icon icon="link" iconSize="14" className="icon" />
                              {this.props.circle.products[0].url}
                            </a>
                          )}
                          <hr className="separator" />
                          <div
                            className="mobile-content-expand"
                            onClick={() => {
                              this.setState({ expanded: true });
                            }}>
                            <Icon icon="more" iconSize="24" className="icon" />
                          </div>
                          {this.props.circle.description}
                        </div>
                        <StickyBox offsetTop={80} offsetBottom={80}>
                          <div className="product-side-info default-circle">
                            <h2>
                              <Translate value="circle.ready_to_co_own" />
                              {this.props.circle.status === "completed" && (
                                <span style={{ float: "right" }}>
                                  <CircleStatus circle={this.props.circle} />
                                </span>
                              )}
                            </h2>

                            <div className="product-split">
                              <div className="split-item product-location">
                                <Icon icon="map-marker" iconSize="24" className="icon" />
                                <strong>
                                  {this.props.circle.address ? this.props.circle.address : this.props.circle.country}
                                </strong>
                                <Translate value="circle.location" />
                              </div>
                              <div className="split-item product-owners">
                                <Icon icon="people" iconSize="24" className="icon" />
                                <strong>
                                  {this.props.circle.members.length}/{this.props.circle.max_owners_no}
                                </strong>
                                <Translate value="circle.co_owners" />
                              </div>
                              <div className="split-item product-price">
                                <CustomIcon name="money-bills" size="24" className="icon" />

                                <strong>
                                  <FormatedPrice
                                    value={this.props.circle.products[0].price / this.props.circle.max_owners_no}
                                    currency_type={this.props.circle.products[0].currency}
                                  />
                                </strong>
                                <Translate value="circle.per_person" />
                              </div>
                            </div>
                            {["member_gathering", "pending"].includes(this.props.circle.status) && (
                              <>
                                <JoinRequestDecorator circleId={this.props.circle.guid}>
                                  <div className="product-cta">
                                    <Button intent="primary" className="cta" fill={true}>
                                      {this.props.is_white_monday ? (
                                        <Translate value="circle.white_monday_join" />
                                      ) : (
                                        <Translate value="circle.start_co_owning" />
                                      )}
                                    </Button>
                                  </div>
                                </JoinRequestDecorator>
                                <div className="commitment-info">
                                  <Translate value="circle.commitment_info" />
                                </div>
                              </>
                            )}

                            <UserDecorator userId={this.props.circle.created_by}>
                              <CircleCreator />
                            </UserDecorator>
                          </div>
                        </StickyBox>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    loadingCircle: isFetchingCircle(state, props.circleId),
    circle: getCircleWithId(state, props.circleId),
    is_white_monday: isWhiteMondayCircle(state, props.circleId),
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchCircle: (id) => dispatch(fetchCircle(id)),
  navigate: (to) => dispatch(navigate(to)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CirclePresentation);
